import React, { useState, useEffect } from "react";
import "./Reports.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FaLongArrowAltLeft } from "react-icons/fa";
// import Loading from "../Loader/Loading";
// import myImage from "../../assets/183.png";

const Report = () => {
  const [filterdata, setfilterdata] = useState({
    Task: [],
    NL: [],
    Daily: [],
  });
  const [filters, setfilters] = useState({
    selectedName: "",
    dept: "",
    report: "",
    status: "",
    startdate: "",
    enddate: "",
  });
  const [dateError, setDateError] = useState("");
  const [showopenedOptions, setShowopenedOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { users = [] } = location.state || {};

  const [isreportopen, setisreportopen] = useState(false);

  const [page1, setPage1] = useState(1); // For daily
  const [page2, setPage2] = useState(1); // For task
  const [page3, setPage3] = useState(1); // For nl
  const itemsPerPage = 10;

  const paginatedData1 = Object.entries(
    filterdata.Daily.reduce((acc, curr) => {
      const groupKey = `${curr.submit_date}|${curr.time_slot}`;
      if (!acc[groupKey]) acc[groupKey] = [];
      acc[groupKey].push(curr);
      return acc;
    }, {})
  ).slice((page1 - 1) * itemsPerPage, page1 * itemsPerPage);

  const paginatedData2 = filterdata.Task.slice(
    (page2 - 1) * itemsPerPage,
    page2 * itemsPerPage
  );
  const paginatedData3 = filterdata.NL.slice(
    (page3 - 1) * itemsPerPage,
    page3 * itemsPerPage
  );

  const groupedData1 = Object.entries(
    filterdata.Daily.reduce((acc, curr) => {
      const groupKey = `${curr.submit_date}|${curr.time_slot}`;
      if (!acc[groupKey]) acc[groupKey] = [];
      acc[groupKey].push(curr);
      return acc;
    }, {})
  );

  const totalPages1 = Math.ceil(groupedData1.length / itemsPerPage);
  const totalPages2 = Math.ceil(filterdata.Task.length / itemsPerPage);
  const totalPages3 = Math.ceil(filterdata.NL.length / itemsPerPage);

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const Navigate = useNavigate();

  const selectedEmp = users.find(
    (emp) => emp.emp_name === filters?.selectedName
  );
  const selectedId = selectedEmp?.id;

  const handlehomepage = () => {
    Navigate("/ad");
  };

  const handleSubmit = () => {
    // Validate date range
    if (filters.startdate || filters.enddate) {
      if (!filters.startdate || !filters.enddate) {
        setDateError("Both start date and end date must be selected.");
        return;
      }

      if (new Date(filters.startdate) > new Date(filters.enddate)) {
        setDateError("Start date must be earlier than end date.");
        return;
      }

      setDateError("");
    } else {
      setDateError("");
    }

    handleFilterData();
  };

  const handleFilterData = async () => {
    if (
      selectedId ||
      filters.dept ||
      filters.report ||
      filters.status ||
      (filters.startdate && filters.enddate)
    ) {
      setIsLoading(true);
      setisreportopen(true);
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/report.php`;
      const formData = new FormData();

      formData.append("user_id", selectedId || "");
      formData.append("dept", filters?.dept || "");
      formData.append("type", filters?.report || "");
      formData.append("status", filters?.status || "");
      formData.append("start_date", filters.startdate || "");
      formData.append("end_date", filters.enddate || "");

      try {
        setfilterdata({
          Task: [],
          NL: [],
          Daily: [],
        });
        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (data.message === "Records fetched successfully") {
          setfilterdata((pv) => ({
            ...pv,
            Task: data.task || [],
            Daily: data["daily report"] || [],
            NL: data["new learning"] || [],
          }));
        } else {
          setfilterdata({
            Task: [],
            NL: [],
            Daily: [],
          });
        }
      } catch (error) {
        console.log("Error with POST request:", error);
        setfilterdata({
          Task: [],
          NL: [],
          Daily: [],
        });
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Please enter all the required fields");
    }
  };

  const handlereportdownload = async (type) => {
    if (
      !selectedId &&
      !filters.dept &&
      !filters.report &&
      !filters.status &&
      !filters.startdate &&
      !filters.enddate
    ) {
      alert("Please select at least one filter.");
      return;
    }

    // Extract and encode values
    const userId = encodeURIComponent(selectedId);
    const dept = encodeURIComponent(filters.dept);
    const report = encodeURIComponent(filters.report);
    const status = encodeURIComponent(filters.status);
    const startDate = encodeURIComponent(filters.startdate);
    const endDate = encodeURIComponent(filters.enddate);
    const fileType = type === "pdf" ? "pdf" : "csv";

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/report_download.php?user_id=${userId}&type=${report}&dept=${dept}&status=${status}&start_date=${startDate}&end_date=${endDate}&type2=${fileType}`;

    try {
      const response = await fetch(apiUrl, { method: "GET" });
      const contentType = response.headers.get("Content-Type");

      if (!response.ok || !contentType.includes(fileType)) {
        const text = await response.text();
        console.error("Unexpected response:", text);
        alert("No data or wrong format returned.");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `report-${filters.startdate}-${filters.enddate}.${fileType}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
      alert("There was an error downloading the report.");
    }
  };

  return (
    <>
      <div className="align">
        <button className="button" onClick={handlehomepage}>
          <svg className="svg">
            <FaLongArrowAltLeft />
          </svg>
          <div className="tet">Home</div>
        </button>
      </div>
      <div className="report-layout">
        <div className="report-container">
          <h1 className="head">REPORT</h1>

          <div className="filter-section">
            {/* dept Filters */}
            <div className="date-range-group">
              <label className="date-label">Choose a Department:</label>
              <input
                className="datePicker"
                placeholder="Department"
                list="Department"
                id="vendors"
                name="vendor"
                value={filters?.dept}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    dept: e.target.value,
                    selectedName: "",
                  }))
                }
              />

              <datalist id="Department">
                <option value="admin">Admin</option>
                <option value="hr">Human Recourses</option>
                <option value="recuitement">Recuitement</option>
                <option value="development">Development</option>
                <option value="accounts">Accounts</option>
                <option value="sales">Sales</option>
                <option value="support">Support</option>
                <option value="training">Training</option>
              </datalist>
            </div>

            {/* emp Filters */}
            {!filters?.dept && (
              <div className="date-range-group">
                <label className="date-label">Choose a Employee:</label>
                <input
                  className="datePicker"
                  placeholder="Employee"
                  list="EmployeeList"
                  id="employee"
                  name="employee"
                  value={filters?.selectedName}
                  onChange={(e) => {
                    setfilters((prevFilters) => ({
                      ...prevFilters,
                      selectedName: e.target.value,
                    }));
                  }}
                />

                <datalist id="EmployeeList">
                  {users
                    .filter(
                      (userDetails) =>
                        !["admin", "executive"].includes(userDetails?.role)
                    )
                    .map((emp, index) => (
                      <option key={index}>{emp?.emp_name}</option>
                    ))}
                </datalist>
              </div>
            )}

            {/* task Filters */}
            <div className="date-range-group">
              <label className="date-label">Choose a Report:</label>
              <select
                id="vendors"
                name="vendor"
                value={filters?.report}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    report: e.target.value,
                  }))
                }
              >
                <option value="" disabled>
                  Select Report
                </option>
                <option value="all reports">All Report</option>
                <option value="task">Task Report</option>
                <option value="new learning">New Learning</option>
                <option value="daily">Daily Work Sheet</option>
              </select>
            </div>

            {/* from Date Filters */}
            <div className="date-range-group">
              <label
                //  htmlFor="startDate"
                className="date-label"
              >
                From
              </label>
              <input
                type="date"
                className="datePicker"
                name="startDate"
                id="startDate"
                value={filters.startdate}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    startdate: e.target.value,
                  }))
                }
              />
            </div>

            {/* to Date Filters */}
            <div className="date-range-group">
              <label
                //  htmlFor="endDate"
                className="date-label"
              >
                To
              </label>
              <input
                type="date"
                className="datePicker"
                name="endDate"
                id="endDate"
                value={filters.enddate}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    enddate: e.target.value,
                  }))
                }
              />
            </div>

            {/* status Filters */}
            {filters?.report !== "daily" ? (
              <>
                {/* status Filters */}
                <div className="date-range-group">
                  <label className="date-label">Choose a Status:</label>
                  <select
                    id="vendors"
                    name="vendor"
                    value={filters?.status}
                    onChange={(e) =>
                      setfilters((prevFilters) => ({
                        ...prevFilters,
                        status: e.target.value,
                      }))
                    }
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="all">All</option>
                    <option value="Assigned">Assigned</option>
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                  </select>
                </div>
              </>
            ) : (
              true
            )}

            {dateError && <div className="error-msg">{dateError}</div>}
          </div>

          <div className="download-buttons">
            <div className="sbt">
              <button className="shbn" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>

          {/* {isLoading && <Loading type="report" />} */}

          {isreportopen && (
            <>
              {filterdata.Task.length === 0 &&
              filterdata.Daily.length === 0 &&
              filterdata.NL.length === 0 ? (
                <div className="images">
                  {/* <img src={myImage} alt="Description" /> */}
                  <div className="notickets">
                    🔍 No filters found for the Matching Result.
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="download-wrapper"
                    onClick={() => setShowopenedOptions(true)}
                    onMouseLeave={() => setShowopenedOptions(false)}
                  >
                    <button className="downbtn">Download</button>
                    {showopenedOptions && (
                      <div className="download-actions">
                        <button onClick={() => handlereportdownload("pdf")}>
                          PDF
                        </button>
                        <button onClick={() => handlereportdownload("csv")}>
                          Excel
                        </button>
                      </div>
                    )}
                  </div>
                  {/* TASK REPORT  */}
                  {filterdata.Task.length > 0 ? (
                    <>
                      <div className="table-contain">
                        <h6 className="heading">TASK REPORT</h6>
                        <div className="table-scroll">
                          <table className="report-table">
                            <thead>
                              <tr>
                                <th>SI.NO</th>
                                <th>Employee Name</th>
                                <th>Phone Number</th>
                                <th>Department</th>
                                <th>Task</th>
                                <th>Status</th>
                                <th>Assigned</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedData2.length > 0 ? (
                                paginatedData2.map((item, index) => (
                                  <tr key={item.id}>
                                    <td className="tdh">
                                      {(page2 - 1) * itemsPerPage + index + 1}.
                                    </td>
                                    <td>{item.emp_name}</td>
                                    <td>{item.phone_no}</td>
                                    <td>{item.dept}</td>
                                    <td>{item.task}</td>
                                    <td>{item.status}</td>
                                    <td>
                                      <strong>{item.assign_name} </strong>
                                      {item.assign_date}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7">No data found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {totalPages2 > 1 && (
                          <div className="pagination">
                            <button
                              onClick={() =>
                                setPage2((p) => Math.max(p - 1, 1))
                              }
                              disabled={page2 === 1}
                            >
                              Prev
                            </button>
                            <span>
                              Page {page2} of {totalPages2}
                            </span>
                            <button
                              onClick={() =>
                                setPage2((p) => (p < totalPages2 ? p + 1 : p))
                              }
                              disabled={page2 >= totalPages2}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : null}

                  {/* New Learning REPORT  */}
                  {filterdata.NL.length > 0 ? (
                    <>
                      <div className="table-contain">
                        <h6 className="heading">NEW LEARNING</h6>
                        <div className="table-scroll">
                          <table className="report-table">
                            <thead>
                              <tr>
                                <th>SI.NO</th>
                                <th>Employee Name</th>
                                <th>Phone Number</th>
                                <th>Department</th>
                                <th>Task</th>
                                <th>Submitted Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedData3.length > 0 ? (
                                paginatedData3.map((item, index) => (
                                  <tr key={item.id}>
                                    <td className="tdh">
                                      {(page3 - 1) * itemsPerPage + index + 1}.
                                    </td>
                                    <td>{item.emp_name}</td>
                                    <td>{item.phone_no}</td>
                                    <td>{item.dept}</td>
                                    <td>{item.task}</td>
                                    <td>{item.submit_date}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7">No data found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {totalPages3 > 1 && (
                          <div className="pagination">
                            <button
                              onClick={() =>
                                setPage3((p) => Math.max(p - 1, 1))
                              }
                              disabled={page3 === 1}
                            >
                              Prev
                            </button>
                            <span>
                              Page {page3} of {totalPages3}
                            </span>
                            <button
                              onClick={() =>
                                setPage3((p) => (p < totalPages3 ? p + 1 : p))
                              }
                              disabled={page3 >= totalPages3}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : null}

                  {/* DAILY REPORT  */}
                  {filterdata.Daily.length > 0 ? (
                    <>
                      <div className="table-contain">
                        <h1 className="heading">DAILY WORK REPORT</h1>
                        <div className="table-scroll">
                          <table className="report-table">
                            <thead>
                              <tr>
                                <th>SI.NO</th>
                                <th>Employee Name</th>
                                <th>Phone Number</th>
                                <th>Department</th>
                                <th style={{ width: "50px" }}>Time Slot</th>
                                <th>Task</th>
                                <th>Submitted Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedData1.length > 0 ? (
                                paginatedData1.map(([key, records], index) => {
                                  const [submit_date, time_slot] =
                                    key.split("|");
                                  const first = records[0];
                                  return (
                                    <tr key={index}>
                                      <td className="tdh">
                                        {(page1 - 1) * itemsPerPage + index + 1}
                                        .
                                      </td>
                                      <td>{first.emp_name}</td>
                                      <td>{first.phone_no}</td>
                                      <td>{first.dept}</td>
                                      <td style={{ whiteSpace: "nowrap" }}>
                                        {time_slot}
                                      </td>
                                      <td>
                                        {records.map((item, idx) => {
                                          const task = item.task;
                                          const isFile =
                                            /\.(pdf|docx?|xlsx?|png|jpe?g|txt)$/i.test(
                                              task
                                            );
                                          return (
                                            <div
                                              key={idx}
                                              style={{ marginBottom: "6px" }}
                                            >
                                              {isFile ? (
                                                <a
                                                  href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${task}`}
                                                  target="_blank"
                                                  download
                                                  style={{
                                                    color: "#007bff",
                                                    textDecoration: "underline",
                                                  }}
                                                >
                                                  {task}
                                                </a>
                                              ) : (
                                                <span>{task}</span>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </td>
                                      <td>{submit_date}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="7">No data found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {totalPages1 > 1 && (
                          <div className="pagination">
                            <button
                              onClick={() =>
                                setPage1((p) => Math.max(p - 1, 1))
                              }
                              disabled={page1 === 1}
                            >
                              Prev
                            </button>
                            <span>
                              Page {page1} of {totalPages1}
                            </span>
                            <button
                              onClick={() =>
                                setPage1((p) => (p < totalPages1 ? p + 1 : p))
                              }
                              disabled={page1 >= totalPages1}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : null}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Report;
